import { Feature, FeatureMapping } from '@loyalty/shared-common';
import {
  RuleAttributes,
  RuleInput,
  replaceRulesRuleInputSchema,
} from '@loyalty/shared-common/rule-api-client';

export function ruleAttributesToRuleInput(rule: RuleAttributes): RuleInput {
  return {
    legacyAccountId: rule.accountId,
    name: rule.name,
    type: rule.type,
    eventSource: rule.eventSource,
    eventName: rule.eventName,
    i18nAttributes: rule.i18nAttributes,
    criteria: rule.criteria,
    actions: rule.actions,
    options: rule.options ?? {},
  };
}

export function ruleAttributesListToRuleInputs(rules: RuleAttributes[]): RuleInput[] {
  return rules.map(ruleAttributesToRuleInput);
}

export function parseRuleInputsJson(json: string): RuleInput[] {
  const parsed = JSON.parse(json);
  if (!Array.isArray(parsed)) {
    throw new Error('Expected a JSON array');
  }
  return parsed.map((rule, index) => {
    const validationResult = replaceRulesRuleInputSchema.validate(rule, {
      abortEarly: true,
      convert: true,
      presence: 'required',
      stripUnknown: true,
    });
    if (validationResult.error) {
      throw new Error(`Rule at index ${index}: ${validationResult.error.message}`);
    }
    return validationResult.value as unknown as RuleInput;
  });
}

export function canUseRulesImportExport(
  features: FeatureMapping<boolean>,
  ruleType: 'EARNING_RULE' | 'BURNING_RULE',
): boolean {
  const gate = features[Feature.RULES_IMPORT_EXPORT];
  if (!gate) {
    return false;
  }
  return ruleType === 'EARNING_RULE' ? !!gate.earning : !!gate.burning;
}

export function canImportExportRules(
  features: FeatureMapping<boolean>,
  ruleType: 'EARNING_RULE' | 'BURNING_RULE',
): boolean {
  const ruleFeature = ruleType === 'EARNING_RULE' ? Feature.EARNING_RULE : Feature.BURNING_RULE;
  const rf = features[ruleFeature];
  return canUseRulesImportExport(features, ruleType) && !!rf?.read;
}
